import app from '../app';

app.controller("CustomerLoginController", CustomerLoginController);

/*@ngInject*/
function CustomerLoginController() {
    var vm = this;

    vm.loginModel = {};
    vm.loginFields = [
        {
            key: '_username',
            name: '_username',
            type: 'input',
            templateOptions: {
                labelOptions: {
                    label: 'Email Address'
                },
                placeholder: 'Email Address',
                required: true,
                "type": "email"
            }
        },
        {
            key: '_password',
            type: 'input',
            name: '_password',
            templateOptions: {
                labelOptions: {
                    label: 'Password'
                },
                type: 'password',
                placeholder: 'Password',
                required: true
            }
        }
    ];
}




// WEBPACK FOOTER //
// ./static/js/app/customer/customer.login.controller.js